import { z } from "zod";

// Mensajes literales de SPEC-208 §7 (GOAL_INVALID / WINDOW_INVALID): son el
// contrato de UX, no una redacción libre — el servidor devuelve el mismo
// código si el cliente los saltea.
export const GOAL_INVALID_MESSAGE = "La meta debe ser un número mayor que cero";
export const WINDOW_INVALID_MESSAGE =
  "La ventana debe expresarse en meses, mayor que cero";

export const grandPrizeFormSchema = z.object({
  nameEs: z.string().trim().min(1, "El nombre del premio es obligatorio"),
  nameEn: z.string(),
  descriptionEs: z.string(),
  descriptionEn: z.string(),
  imageUrl: z.string(),
  // PLAN-007 Fase 4d: id del archivo ya subido y confirmado
  // (`uploadImage`/`FileUploadChip`), con prioridad sobre `imageUrl` en el
  // servidor (GrandPrizeInput.imageFileId). Vacío cuando el operador no
  // tocó la imagen en esta sesión del formulario.
  imageFileId: z.string(),
  goal: z.number().int(GOAL_INVALID_MESSAGE).positive(GOAL_INVALID_MESSAGE),
  windowMonths: z
    .number()
    .int(WINDOW_INVALID_MESSAGE)
    .positive(WINDOW_INVALID_MESSAGE),
  active: z.boolean(),
});
export type GrandPrizeFormValues = z.infer<typeof grandPrizeFormSchema>;
